import axios from '../axios-on-rails';

class MemberRecommendationSearch {
  constructor() {
    this.debounceCheckAllMember = this.debounce(this.ajaxCheckAllMember.bind(this));
    this.debounceCheckSingleMember = this.debounce(this.ajaxCheckSingleMember.bind(this));
  }

  getSearchSessionId() {
    const url = new URLSearchParams(window.location.search);
    return url.get('searchsession');
  }

  getResultId() {
    const url = new URLSearchParams(window.location.search);
    return url.get('result_id');
  }

  getSearchJobId() {
    const url = new URLSearchParams(window.location.search);
    return url.get('search[job_id]');
  }

  debounce(func, delay = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  ajaxCheckAllMember(checked, displayIgnored) {
    const endpoint = Routes[`${checked ? '' : 'un'}check_all_member_recommendation_search_index_path`];
    axios({
      method: checked ? 'post' : 'delete',
      url: endpoint(gon.locale),
      data: {
        format: gon.locale,
        q: { display_ignored: displayIgnored },
        searchsession: this.getSearchSessionId(),
        result_id: this.getResultId(),
        search: { job_id: this.getSearchJobId() },
      }
    }).then(({ data, status }) => {
      if (status == 200) {
        $('.js-checkbox-jobfolder').prop('checked', checked);
        $('.js-checkbox-all').prop('checked', data.all_members_checked);
        this.showHideNotice(data.total_member_checked);
      }
    });
  }

  toggleCheckAll(target, displayIgnored) {
    const checked = $(target).prop('checked');
    this.debounceCheckAllMember(checked, displayIgnored);
  }

  ajaxCheckSingleMember(checked, memberId, displayIgnored) {
    const endpoint = Routes[`${checked ? '' : 'un'}check_single_member_member_recommendation_search_index_path`];
    axios({
      method: checked ? 'post' : 'delete',
      url: endpoint(gon.locale),
      data: {
        format: gon.locale,
        member_id: memberId,
        q: { display_ignored: displayIgnored },
        searchsession: this.getSearchSessionId(),
        result_id: this.getResultId()
      }
    }).then(({ data, status }) => {
      if (status == 200) {
        $('.js-checkbox-all').prop('checked', data.all_members_checked);
      }
    })
  }

  checkboxOne(target, displayIgnored) {
    const memberId = $(target).val();
    const checked = $(target).prop("checked");
    let totalMemberSelected = parseInt($('[data-target="memberCount"]').text());
    totalMemberSelected = checked ? (totalMemberSelected + 1) : (totalMemberSelected - 1);
    this.showHideNotice(totalMemberSelected);
    this.debounceCheckSingleMember(checked, memberId, displayIgnored);
  }

  showHideNotice(num) {
    let noticeElement = $('[data-target="notice"]')
    let memberCountElement = noticeElement.find('[data-target="memberCount"]');
    let scoutAvailable = memberCountElement.data('available');

    if (num > scoutAvailable) {
      noticeElement.addClass('alert alert-danger');
      $('[data-btn="sendAll"]').addClass('disabled');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      noticeElement.removeClass('alert alert-danger');
      $('[data-btn="sendAll"]').removeClass('disabled');
    }
    memberCountElement.text(num);
  }

  fetchAndApplyFilters(jobId) {
    clearTimeout(this.filterFetchTimeout)
    this.filterFetchTimeout = setTimeout(() => {
      this.fetchAndApplyFiltersAux(jobId)
    }, 200)
  }

  filterFetchMemo = {};

  fetchAndApplyFiltersAux(jobId) {
    jobId = Number(jobId)
    if (jobId < 1) return

    const url = Routes.fetch_saved_filters_member_recommendation_search_index_path(gon.locale, { search: { job_id: jobId } });

    this.latestFilterJobId = jobId

    this.filterFetchMemo[jobId] ||= axios.get(url)

    this.filterFetchMemo[jobId]
      .then(response => {
        if (response.data.trim() === '') return

        // This is to prevent glitches from changing too quickly.
        if (this.latestFilterJobId !== jobId) return

        const doc = (new DOMParser()).parseFromString(response.data, 'text/html')

        // From the server-rendered form, get each individual input and replace it.
        // Patching the whole form is not possible, because it includes the <form>
        // tag and other tags like table, etc.
        doc.querySelectorAll('[id][name]').forEach(element => {
          if (!element.getAttribute('name').startsWith('search[')) return

          const id = element.getAttribute('id')
          document.getElementById(id).replaceWith(element)
        })
      })
      .catch(error => console.error('Error:', error));
  }
}

export default MemberRecommendationSearch;
